<template>
    <div class="vehicle-results">

        <input name="location_code" :value="locationCode" type="hidden">
        <input name="vehicle_slug" :value="vehicleSlug" type="hidden">

        <div class="results">
            <throbber-overlay
                    v-if="busy"
                    display="toast"
                    v-bind:message="loadingMessage"
            ></throbber-overlay>

            <template v-if="vehicleResults.error">
                <div class="no-results error">
                    <h2 v-if="!hideTitle">No results</h2>

                    <p class="error">

                        <template v-if="busy">
                            Loading...
                        </template>
                        <template v-if="!busy">
                            Sorry, there was an error performing your search:<br>
                            <em>{{vehicleResults.error}}</em> <br><br>

                            <template v-if="vehicleResults.errorData && vehicleResults.errorData.locations">
                                <template v-for="location in vehicleResults.errorData.locations">
                                    <h5>{{location.name}}</h5>
                                    <p class="pl-3">
                                        <template v-for="hours in location.open_hours">
                                            <strong>{{hours[0]}}</strong>: {{hours[1]}}<br>
                                        </template>
                                    </p>
                                </template>
                            </template>

                            <br><br>

                            <button
                                    class="button"
                                    @click="$_requestSearch"
                            >Please try again
                            </button>
                        </template>

                    </p>


                </div>
            </template>


            <template v-else>
                <div class="detailCards" v-if="vehicleResults.matches.length > 0">

                    <h2 v-if="!hideTitle">Results</h2>


                    <div class="tabs" v-if="useTabs && types.length > 0">
                        <ul>
                            <li
                                    v-for="type in types"
                                    v-bind:class="{active: type.slug === currentTab}"
                                    @click="$_changeTab(type.slug)"
                            >{{type.name}}
                            </li>
                        </ul>
                    </div>


                    <div class="detailCard" v-for="vehicle in pageData">
                        <header>
                            <h5 class="title">{{vehicle.name}}</h5>
                            <h6 class="sub-title">{{vehicle.code}}</h6>
                        </header>

                        <div class="detail">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-3 vehicle-image" v-if="vehicle.image">
                                        <span v-if="vehicle.image" v-html="vehicle.image"></span>
                                    </div>
                                    <div class="col-md-9 col-lg-9 vehicle-details">
                                        <template v-for="(fields, category) in vehicle.ordered_fields">
                                            <h4>{{category}}</h4>
                                            <ul>
                                                <li v-for="field in fields">
                                                    {{field}}
                                                </li>
                                            </ul>
                                        </template>

                                    </div>


                                    <div class="col-12 text-center">
                                        <label class="button mt-3">
                                            <input  v-model="showRates[vehicle.code]" type="checkbox" class="d-none">
                                            <template v-if="showRates[vehicle.code]">Hide</template>
                                            <template v-if="!showRates[vehicle.code]">Show</template>
                                            Rate Details
                                        </label>
                                    </div>

                                    <div class="col-12 vehicle-actions align-items-end flex-column">
                                        <div class="w-100">
                                            <ul>
                                                <li
                                                        class="p-0"
                                                        v-for="(status, location) in vehicle.status_at_location">

                                                    <div class="col-12" v-if="showRates[vehicle.code]">
                                                        <div class="container-fluid p-0">
                                                            <div class="row" v-if="vehicle.included_charges[location]">
                                                                <div class="col-12 mt-3 vehicle-rates">
                                                                    <div class="container-fluid">
                                                                        <div class="row">
                                                                            <h4 class="col-md-12">{{vehicle.location_names[location]}}</h4>

                                                                            <div class="col-md-6" v-if="vehicle.included_charges[location]">
                                                                                <strong>Included in total</strong>
                                                                                <ul>
                                                                                    <li v-for="charge in vehicle.included_charges[location]">
                                                                                        <span v-html="charge['@attributes'].Description"></span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            <div class="col-md-6" v-if="vehicle.excluded_charges[location]">
                                                                                <strong>Excluded</strong>
                                                                                <ul>
                                                                                    <li v-for="charge in vehicle.excluded_charges[location]">
                                                                                        <span v-html="charge['@attributes'].Description"></span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row" v-if="vehicle.warnings && vehicle.warnings[location]">
                                                                <div class="col-12 vehicle-rates">
                                                                    <strong>Warnings</strong>
                                                                    <ul>
                                                                        <li v-for="charge of vehicle.warnings[location]">
                                                                            <span v-html="charge"></span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <strong>{{vehicle.location_names[location]}}</strong> &nbsp;
                                                    <a
                                                            v-if="parentForm !== null"
                                                            v-bind:class="{
                                                              disabled: !canSubmit,
                                                              'is-book': status === 10,
                                                              'is-request': status === 20,
                                                            }"
                                                            @click="$_book(location, vehicle.slug)"
                                                            v-bind:data-hover-tooltip="getBookButtonTooltip(status)"
                                                    >
                                                        <span
                                                              v-bind:class="{
                                                                button: true,
                                                                'button--alt': status === 20
                                                              }"
                                                        >
                                                            <template v-if="status === 10">
                                                                Book
                                                                for
                                                                <strong>${{vehicle.estimated_total[location]}}</strong>
                                                            </template>
                                                            <template v-if="status === 20">
                                                                Request Vehicle
                                                            </template>
                                                        </span>
                                                    </a>
                                                    <span class="estimated-cost">Estimated cost of ${{vehicle.estimated_total[location]}}</span>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div v-if="pages > 1" class="pagination">
                        <button class="button" :disabled="page === 0" @click="previousPage">Previous</button>
                        <button class="button" :disabled="page >= pages - 1" @click="nextPage">Next</button>
                    </div>
                </div>

                <div class="no-results" v-if="vehicleResults.matches.length === 0">

                    <h2 v-if="!hideTitle">Results</h2>

                    <template v-if="busy">
                        Loading...
                    </template>
                    <template v-if="!busy">
                        No results found.
                    </template>

                </div>

                <div class="detailCards similar pt-3" v-if="vehicleResults.similar.length > 0">
                    <h2>Similar vehicles</h2>
                    <div class="detailCard" v-for="vehicle in vehicleResults.similar">
                        <header>
                            <h5 class="title">{{vehicle.name}}</h5>
                            <h6 class="sub-title">{{vehicle.code}}</h6>
                        </header>

                        <div class="detail">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-3 vehicle-image" v-if="vehicle.image">
                                        <span v-if="vehicle.image" v-html="vehicle.image"></span>
                                    </div>
                                    <div class="col-md-9 col-lg-9 vehicle-details">
                                        <template v-for="(fields, category) in vehicle.ordered_fields">
                                            <h4>{{category}}</h4>
                                            <ul>
                                                <li v-for="field in fields">
                                                    {{field}}
                                                </li>
                                            </ul>
                                        </template>

                                    </div>

                                    <div class="col-12 text-center">
                                        <label class="button mt-3">
                                            <input  v-model="showRates[vehicle.code]" type="checkbox" class="d-none">
                                            <template v-if="showRates[vehicle.code]">Hide</template>
                                            <template v-if="!showRates[vehicle.code]">Show</template>
                                            Rate Details
                                        </label>
                                    </div>

                                    <div class="col-12 vehicle-actions align-items-end flex-column">
                                        <div class="w-100">
                                            <ul>
                                                <li
                                                        class="p-0"
                                                        v-for="(status, location) in vehicle.status_at_location">

                                                    <div class="col-12" v-if="showRates[vehicle.code]">
                                                        <div class="container-fluid p-0">
                                                            <div class="row" v-if="vehicle.included_charges[location]">
                                                                <div class="col-12 mt-3 vehicle-rates">
                                                                    <div class="container-fluid">
                                                                        <div class="row">
                                                                            <h4 class="col-md-12">{{vehicle.location_names[location]}}</h4>

                                                                            <div class="col-md-6" v-if="vehicle.included_charges[location]">
                                                                                <strong>Included in total</strong>
                                                                                <ul>
                                                                                    <li v-for="charge in vehicle.included_charges[location]">
                                                                                        <span v-html="charge['@attributes'].Description"></span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            <div class="col-md-6" v-if="vehicle.excluded_charges[location]">
                                                                                <strong>Excluded</strong>
                                                                                <ul>
                                                                                    <li v-for="charge in vehicle.excluded_charges[location]">
                                                                                        <span v-html="charge['@attributes'].Description"></span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="vehicle.warnings && vehicle.warnings[location]">
                                                                <div class="col-12 vehicle-rates">
                                                                    <strong>Warnings</strong>
                                                                    <ul>
                                                                        <li v-for="charge of vehicle.warnings[location]">
                                                                            <span v-html="charge"></span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <strong>{{vehicle.location_names[location]}}</strong> &nbsp;
                                                    <a
                                                            v-if="parentForm !== null"
                                                            v-bind:class="{
                                                              disabled: !canSubmit,
                                                              'is-book': status === 10,
                                                              'is-request': status === 20,
                                                            }"
                                                            @click="$_book(location, vehicle.slug)"
                                                            v-bind:data-hover-tooltip="getBookButtonTooltip(status)"
                                                    >
                                                        <span
                                                              v-bind:class="{
                                                                button: true,
                                                                'button--alt': status === 20
                                                              }"
                                                        >
                                                          <template v-if="status === 10">
                                                                Book
                                                                for
                                                                <strong>${{vehicle.estimated_total[location]}}</strong>
                                                            </template>
                                                            <template v-if="status === 20">
                                                                Request Vehicle
                                                            </template>
                                                        </span>
                                                    </a>
                                                    <span class="estimated-cost">Estimated cost of ${{vehicle.estimated_total[location]}}</span>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .vehicle-results ::v-deep {
        .results {
            position: relative;
        }

        .no-results {
            margin-bottom: 2em;
        }

        .pagination {
            margin: 1em;
            justify-content: center;

            button {
                margin: 0.25em;
            }
        }

        .tabs {
            $tabColor: #ccc;
            $spacing: 0.25rem;
            $lightenAmount: 15%;

            border-bottom: 1px solid $tabColor;

            ul {
                &, li {
                    display: flex;
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                li {
                    background: lighten($tabColor, $lightenAmount);
                    padding: $spacing * 3;
                    border-top-left-radius: $spacing;
                    border-top-right-radius: $spacing;
                    margin: 0 $spacing;
                    border-bottom: 2px solid lighten($tabColor, $lightenAmount);
                    cursor: pointer;

                    &.active {
                        background: lighten($tabColor, $lightenAmount / 2);
                        font-weight: bold;
                        border-bottom: 2px solid #FFCF00;
                    }
                }
            }
        }

    }
</style>


<script>

    const ThrobberOverlay = require('./ThrobberOverlay').default;

    const events = {
        requestedSearch: 'vehicle-type-results:requested-search',
    };

    function _dispatchDomEvent($el, eventName, data = null) {
        let eventData = data === null
            ? {}
            : {detail: data};

        eventData.bubbles = true;

        let event;

        /*event = data === null
            ? new Event(eventName, eventData)
            : new CustomEvent(eventName, eventData);*/
        event = new CustomEvent(eventName, eventData);

        $el.dispatchEvent(event);
    }

    export default {
        components: {
            ThrobberOverlay
        },
        props: {
            perPage: {
                type: Number,
                default: 200,
            },
            initialResults: {
                type: Array,
                default: function () {
                    return []
                },
            },
            useTabs: {
                type: Boolean,
                default: false,
            },
            hideTitle: {
                type: Boolean,
                default: false,
            },
            showPrices: {
                type: Boolean,
                default: false,
            },
            shortButtonLabels: {
                type: Boolean,
                default: false,
            },
        },
        data: () => {
            return {
                busy: false,
                vehicleResults: {matches: [], similar: []},
                page: 0,
                parentForm: null,
                vehicleSlug: '',
                locationCode: '',
                types: [],
                currentTab: null,
                //@todo switch this out to use events and/or the data provided to the results component
                canSubmit: true,
                showRates: {},
                loadingMessage: 'Loading...'
            }
        },
        computed: {
            filteredData: function () {
                return this.vehicleResults.matches.filter(vehicle => !this.useTabs || vehicle.type.slug === this.currentTab);
            },
            pages: function () {
                return Math.ceil(this.filteredData.length / this.perPage);
            },
            pageData: function () {
                const start = this.page * this.perPage,
                    end = start + this.perPage
                ;
                return this.filteredData.slice(start, end);
            }
        },
        mounted() {
            this.$_traceParentForm();

            if (!this.parentForm) {
                console.warn('Could not locate parent form...');
            }

            if (this.initialResults.length > 0) {
                this.setResults({matches: this.initialResults, similar: []});
            }
        },
        methods: {
            setBusy: function (busy = true) {
                if (typeof busy === 'string') {
                    this.loadingMessage = busy;
                    busy = true;
                }
                this.busy = busy;
            },
            setResults: function (results = null) {
                if (!results || !results.matches) {
                    results = results || {};
                    results.matches = [];
                    results.similar = [];
                }

                this.types = [];

                let discoveredTypes = {};

                for (let vehicle of results.matches) {

                    if (discoveredTypes[vehicle.type.slug]) {
                        continue;
                    }

                    discoveredTypes[vehicle.type.slug] = true;
                    this.types.push({
                        slug: vehicle.type.slug,
                        name: vehicle.type.name,
                    })
                    ;
                }

                this.vehicleResults = results;

                this.$_changeTab(this.types.length === 0 ? null : this.types[0].slug);
            },
            nextPage: function (event) {
                if (event) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                }

                this.$_changePage(1);
                return false;
            },
            previousPage: function (event) {
                if (event) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                }

                this.$_changePage(-1);
                return false;
            },
            getBookButtonTooltip: function(vehicleStatus) {
              if (vehicleStatus === 20) {
                return "After submitting your request for this vehicle the branch will contact you to confirm the booking";
              }
              return false;
            },
            $_traceParentForm: function () {
                let current = this.$el;

                while (current.parentNode) {
                    current = current.parentNode;
                    if (current.tagName === 'FORM') {
                        this.parentForm = current;
                        return;
                    }
                    if (current.tagName === 'BODY') {
                        break;
                    }
                }

            },
            $_changePage: function (shift) {
                this.page += shift;
                this.page = Math.max(0, this.page);

                if (typeof this.$el.scrollIntoView === 'function') {
                    //help hide pop, and wait for repaint
                    window.setTimeout(() => {
                        this.$el.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                    }, 100);
                } else {
                    window.scrollTo(0, 0);
                }
            },
            $_book: function (location, vehicle) {
                if (!this.parentForm || !this.canSubmit) {
                    return;
                }

                this.locationCode = location;
                this.vehicleSlug = vehicle;

                window.setTimeout(() => {
                    this.parentForm.submit();
                }, 100);
            },
            $_changeTab: function (slug) {
                this.currentTab = slug;
            },
            $_requestSearch: function (event) {
                event.stopImmediatePropagation();
                event.preventDefault();
                _dispatchDomEvent(this.$el, events.requestedSearch, {});

                return false;
            },
        }
    }
</script>
